<template>
    <div class="comMsgBox" >
        <div class="msgBox">
            <div class="quitBtn">
                <slot name="quitBtn"  v-if="showQuitBtn" >
                    <i @click="cancel" class="iconfont icon-cha1" ></i>
                </slot>
            </div>
            <div class="msgTitle">
                <slot name="title">提示</slot>
            </div>
            <div class="msgContent" >
                <slot name="content"></slot>
            </div>
            <div class="msgBtns">
                <div @click="confirm" >
                    <slot name="confirm">
                        <button class="confirmBtn"> 确认 </button>
                    </slot>
                </div>
                <div @click="cancel" >
                    <slot name="cancel" v-if="showCancelBtn">
                        <button class="cancelBtn" > 取消 </button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        showCancelBtn:{
            type:Boolean,
            default:true
        },
        showQuitBtn:{
            type:Boolean,
            default:true
        },
    },
    data(){
        return {

        }
    },
    methods:{
        cancel(){
            this.$emit("cancelMsg")
        },
        confirm(){
            this.$emit("confirmMsg")
        }
    },
}
</script>
<style lang="scss" scoped>
.comMsgBox{
    position: fixed;
    top: 0%;
    right: 0%;
    bottom: 0%;
    left: 0%;
    z-index: 10000;
    background: rgba(0,0,0,0.5);
}
.msgBox{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    min-width: 500px;
    max-width: 600px;
    min-height: 250px;
    padding-bottom:90px;
    border-radius: 5px;
    box-sizing: border-box;
}
.quitBtn{
    position: absolute;
    right: 15px;
    top: 15px;
    .icon-cha1{
        font-size: 20px;
        color: #ccc;
        cursor: pointer;
    }
}
.msgTitle{
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
}
.msgContent{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #808080;
    padding: 15px;
    line-height: 24px;
}
.msgBtns{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0%;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    .cancelBtn,.confirmBtn{
        border-radius: 5px;
        width: 120px;
        height: 40px;
        font-size: 16px;
        cursor: pointer;
        outline: none;
        margin: 0 40px;
    }
    .cancelBtn{
        border: 1px solid #ccc;
        background: #fff;
        color: #848484;
    }
    .confirmBtn{
        border:none;
        background: #2D9FFF;
        color: #fff;
    }
}
</style>